import React from 'react';
import { Button } from "@/components/ui/button";
import { ShoppingCart } from "lucide-react";

interface ShopHeaderProps {
  cartItemCount: number;
  onCartOpen: () => void;
}

export const ShopHeader = ({ cartItemCount, onCartOpen }: ShopHeaderProps) => {
  // DEBUG: Log received cart count
  console.log('ShopHeader received cartItemCount:', cartItemCount);
  
  return (
    <div className="flex justify-between items-center mb-6">
      <h1 className="text-2xl font-semibold">Apparel Shop</h1>
      <Button 
        onClick={onCartOpen}
        variant="outline"
        className="relative"
      >
        <ShoppingCart className="h-5 w-5 mr-2" />
        <span>Cart</span>
        {/* DEBUG: Always show cart count - force visibility */}
        <span className="absolute -top-2 -right-2 bg-red-600 text-white text-xs font-bold rounded-full h-6 w-6 flex items-center justify-center border-2 border-white shadow-lg z-50">
          {cartItemCount || '0'}
        </span>
        {/* {cartItemCount > 0 && ( ... )} - Original condition */}
      </Button>
    </div>
  );
};
